<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card height="520" class="max-shadow">
        <v-card-title class="pa-1">
          <v-toolbar flat color="white" height="48">
            <v-toolbar-title>Visitor Log</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <search-widget v-model="search" />
              <DatePicker v-model="selectedDate" :max="maxDate" type="date" />
              <v-btn color="primary" flat @click.stop="exportVisitorLog(visitorLog)">export</v-btn>
              <v-btn color="primary" flat @click.stop="advanceExportDialog = true">Advance Export</v-btn>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-data-table
          id="visitorLogTable"
          :headers="visitorLogHeaders"
          :items="visitorLog.slice().reverse()"
          :search="search"
          :loading="progressBar"
          :rows-per-page-items="[5,10,25,50]"
          :pagination.sync="pagination"
          item-key="id"
          no-data-text="No visitors yet"
          class="px-2 pb-2"
          disable-initial-sort
        >
          <v-progress-linear slot="progress" color="primary" indeterminate />
          <template slot="items" slot-scope="props">
            <tr class="row-border" @click="$router.push('visitor-log/' + props.item.id)">
              <td class="tablePadding" style="width: 20px">{{ getIndex(props.index + 1) }}</td>
              <td class="text-xs-left tablePadding" style="width: 40px">
                <avatar :size="40" :text="props.item.name" :src="props.item.photoUri" />
              </td>
              <td class="text-xs-left tablePadding">{{ props.item.name }}</td>
              <td class="text-xs-left tablePadding">{{ props.item.visitorType }}</td>
              <td class="text-xs-left tablePadding">{{ props.item.company }}</td>
              <td class="text-xs-left tablePadding">{{ props.item.hostName }}</td>
              <td class="text-xs-left tablePadding">{{ formatDate(props.item.checkInDate) }}</td>
              <template v-if="props.item.checkOutDate">
                <td class="text-xs-left tablePadding">{{ formatDate(props.item.checkOutDate) }}</td>
              </template>
              <template v-if="!props.item.checkOutDate">
                <td
                  class="text-xs-left red--text tablePadding"
                >{{ getOverStayStatus(props.item.checkInDate) }}</td>
              </template>
              <td class="justify-end layout px-0" style="width:85px">
                <template v-if="!props.item.checkOutDate && showCheckOutButton()">
                  <v-tooltip :open-delay="1500" bottom>
                    <v-btn slot="activator" icon flat @click.stop="checkOutVisitorLog(props.item)">
                      <svg style="width:24px;height:24px;" viewBox="0 0 24 24">
                        <path
                          fill="#757575"
                          d="M17,17.25V14H10V10H17V6.75L22.25,12L17,17.25M13,2A2,2 0 0,1 15,4V8H13V4H4V20H13V16H15V20A2,2 0 0,1 13,22H4A2,2 0 0,1 2,20V4A2,2 0 0,1 4,2H13Z"
                        />
                      </svg>
                    </v-btn>
                    <span>Checkout</span>
                  </v-tooltip>
                </template>
                <v-tooltip :open-delay="1500" bottom>
                  <v-btn
                    slot="activator"
                    icon
                    class="mx-0"
                    @click.stop="deleteVisitorLog(props.item)"
                  >
                    <v-icon color="iconColor">delete</v-icon>
                  </v-btn>
                  <span>Delete</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template slot="no-results">
            <p class="text-xs-center">
              Your search for
              <span class="font-weight-bold subheading">{{ search }}</span> found no results.
            </p>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
    <v-dialog v-model="deleteVisitorLogDialog" max-width="500px">
      <v-card class="max-shadow">
        <v-card-title class="headline">Delete {{ selectedVisitorLog.name }}'s log</v-card-title>
        <v-card-text>
          <div class="subheading">
            Do you want to delete
            <strong>{{ selectedVisitorLog.name }}'s Log</strong>?
            <br />The log will be deleted permanently from the Vizmo server
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" flat @click.native="deleteVisitorLogDialog = false">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="confirmDeleteVisitorLog">delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="advanceExportDialog" max-width="690">
      <v-card class="max-shadow">
        <v-card-title class="headline">Advance Export</v-card-title>
        <v-card-text>
          <v-layout row wrap justify-space-around>
            <v-layout row wrap align-center justify-center>
              <span>Start Date :</span>
              <DatePicker
                v-model="AEStartDate"
                :max="AEEndDate"
                :prev-next-btns="false"
                type="date"
              />
            </v-layout>
            <v-layout row wrap align-center justify-center>
              <span>End Date :</span>
              <DatePicker v-model="AEEndDate" :max="AEEndDate" :prev-next-btns="false" type="date" />
            </v-layout>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" flat @click.native="advanceExportDialog = false">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="advanceExport">Export</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="0" bottom>
      {{ snackbarMessage }}
      <v-btn flat @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
import DatePicker from '@/components/common/DatePicker';
import avatar from '@/components/common/Avatar';
import * as moment from 'moment';
import _get from 'lodash/get';
import { database } from '@/firebase';
import Papa from 'papaparse';
import SearchWidget from '@/components/common/SearchWidget';

export default {
  name: 'VisitorLogTable',
  components: {
    DatePicker,
    avatar,
    'search-widget': SearchWidget
  },
  data() {
    return {
      dateFormat: 'YYYY-MM-DD',
      selectedDate: '',
      maxDate: '',
      startAt: '',
      endAt: '',
      AEStartDate: '',
      AEEndDate: '',
      visitorLog: [],
      activeVisitors: 0,
      totalNoOfVisitors: 0,
      overStayVisitors: 0,
      visitorLogHeaders: [
        {
          text: '#',
          value: false,
          align: 'left',
          width: '10px',
          class: ['tablePadding']
        },
        {
          text: 'Photo',
          value: 'photo',
          align: 'left',
          class: ['tablePadding']
        },
        {
          text: 'Name',
          value: 'name',
          align: 'left',
          class: ['tablePadding']
        },
        {
          text: 'Purpose',
          value: 'visitorType',
          align: 'left',
          class: ['tablePadding']
        },
        {
          text: 'Company',
          value: 'company',
          align: 'left',
          class: ['tablePadding']
        },
        {
          text: 'Host',
          value: 'hostName',
          align: 'left',
          class: ['tablePadding']
        },
        {
          text: 'Check In',
          value: 'checkInDate',
          align: 'left',
          class: ['tablePadding']
        },
        {
          text: 'Check Out',
          value: 'checkOutDate',
          align: 'left',
          class: ['tablePadding']
        },
        {
          text: 'Actions',
          value: 'name',
          sortable: false
        }
      ],
      search: '',
      pagination: {
        rowsPerPage: 10
      },
      firebaseListeners: [],
      selectedVisitorLog: {},
      deleteVisitorLogDialog: false,
      advanceExportDialog: false,
      progressBar: true,
      snackbarMessage: '',
      snackbarColor: 'primary',
      snackbar: false
    };
  },
  computed: {
    logRef() {
      const lid = _get(this.$store.state.VMS, 'lid');
      const role = _get(this.$store.state.profile, 'role');
      const cid = _get(this.$store.state.profile, 'cid');
      // return null if the location ID is not yet set
      if (!lid) return null;
      if (role === 'admin')
        return database.ref(`vms/${lid}/tenants_data/${cid}/visitor_log`);

      return database.ref(`vms/${lid}/visitor_log`);
    }
  },
  watch: {
    logRef: {
      handler(val) {
        if (!val) return;

        this.firebaseListeners.forEach(listenerFunc => {
          val.off('value', listenerFunc);
        });

        this.fetchLog();
      },
      immediate: true
    },
    selectedDate: {
      handler(val) {
        this.startAt = moment
          .utc(val)
          .startOf('day')
          .format();
        this.endAt = moment
          .utc(val)
          .endOf('day')
          .format();

        if (!this.logRef) return;

        this.firebaseListeners.forEach(listenerFunc => {
          this.logRef.off('value', listenerFunc);
        });

        this.fetchLog();
      }
    },
    visitorLog: {
      handler(val) {
        if (!val) return;
        this.progressBar = false;
      },
      immediate: true
    }
  },
  created() {
    this.selectedDate = moment().format(this.dateFormat);
    this.AEStartDate = moment(this.selectedDate)
      .subtract(3, 'days')
      .format(this.dateFormat);
    this.AEEndDate = moment().format(this.dateFormat);
    this.startAt = moment
      .utc()
      .startOf('day')
      .toISOString();
    this.endAt = moment
      .utc()
      .endOf('day')
      .toISOString();
    this.maxDate = moment().format(this.dateFormat);
  },
  beforeDestroy() {
    this.firebaseListeners.forEach(listenerFunc => {
      this.logRef.off('value', listenerFunc);
    });
  },
  methods: {
    fetchLog() {
      const log = this.logRef
        .orderByChild('checkInDate')
        .startAt(this.startAt)
        .endAt(this.endAt)
        .on('value', visitorLogSnapshot => {
          if (visitorLogSnapshot) {
            let ISOArray = [];
            ISOArray = this._toArray(visitorLogSnapshot.val());
            this.visitorLog = ISOArray;
          }
        });
      this.firebaseListeners.push(log);
    },

    _toArray(obj) {
      if (!obj) return [];
      return Object.keys(obj).map(key => {
        const item = obj[key];
        item.id = key;
        return item;
      });
    },

    formatDate(millis) {
      if (millis) {
        return moment(millis).format('h:mm A');
      }
      return '';
    },

    getIndex(index) {
      const { page, rowsPerPage } = this.pagination;
      return index + (page - 1) * rowsPerPage;
    },

    deleteVisitorLog(log) {
      this.selectedVisitorLog = log;
      this.deleteVisitorLogDialog = true;
    },

    confirmDeleteVisitorLog() {
      this.deleteVisitorLogDialog = false;
      const log = this.selectedVisitorLog;

      this.logRef
        .child(log.id)
        .set(null)
        .then(() => {
          this.snackbarColor = 'primary';
          this.snackbarMessage = `${log.name}'s visitor log has been deleted`;
          this.snackbar = true;
        })
        .catch(error => {
          this.snackbarMessage = error;
          this.snackbarColor = 'error';
          this.snackbar = true;
        });
    },
    getOverStayStatus(checkInDate) {
      const today = moment().toISOString();
      const newCheckInDate = moment(checkInDate)
        .add(3, 'hours')
        .toISOString();
      const check = moment(today).isSameOrAfter(newCheckInDate);
      // console.log(check);
      if (check) return 'OVERSTAY';
      return '';
    },

    checkOutVisitorLog(item) {
      const key = item.id;
      const date = moment()
        .utc()
        .toISOString();

      this.logRef
        .child(key)
        .child('checkOutDate')
        .set(date)
        .catch(error => {
          this.snackbarMessage = error;
          this.snackbarColor = 'error';
          this.snackbar = true;
        });
    },

    showCheckOutButton() {
      const endOfDay = moment(this.selectedDate, this.dateFormat)
        .add(1, 'days')
        .valueOf();
      const today = moment().valueOf();
      if (today < endOfDay) return true;
      return false;
    },

    advanceExport() {
      const startAt = moment(this.AEStartDate, this.dateFormat)
        .startOf('day')
        .utc()
        .toISOString();
      const endAt = moment(this.AEEndDate, this.dateFormat)
        .endOf('day')
        .utc()
        .toISOString();
      const log = this.logRef
        .orderByChild('checkInDate')
        .startAt(startAt)
        .endAt(endAt)
        .once('value')
        .then(visitorLogSnapshot => visitorLogSnapshot.val());

      Promise.all([log]).then(results => {
        const AEvisitorLog = this._toArray(results[0]);
        if (AEvisitorLog.length !== 0) {
          this.exportVisitorLog(AEvisitorLog);
          this.advanceExportDialog = false;
        } else {
          this.snackbarMessage =
            'No Logs found to export on the selected dates';
          this.snackbar = true;
          this.advanceExportDialog = false;
        }
      });
    },

    exportVisitorLog(visitorLog) {
      const keys = [
        'name',
        'email',
        'phone',
        'hostName',
        'hostEmail',
        'company',
        'visitorType',
        'photoUri',
        'checkInDate',
        'checkOutDate'
      ];
      const headers = [
        'Name',
        'Email',
        'Phone',
        'Host Name',
        'Host Email',
        'Company',
        'Purpose',
        'Photo URL',
        'Checkin Date',
        'Checkout Date'
      ];
      // const staticKeysLen = 9;
      let rows = [];
      visitorLog.forEach(log => {
        const row = [];
        keys.forEach((key, i) => {
          if (key === 'checkInDate' || key === 'checkOutDate') {
            if (log[key]) {
              row[i] = moment(log[key]).format('DD-MM-YYYY h:mm A');
            } else {
              row[i] = '';
            }
          } else {
            row[i] = log[keys[i]];
          }
        });
        if (log.fields) {
          Object.keys(log.fields).forEach(key => {
            let index = keys.indexOf(key);
            if (index < 0) {
              index = keys.push(key) - 1;
            }
            headers[index] = log.fields[key].label;
            row[index] = log.fields[key].value;
          });
        }
        rows.push(row);
      });

      if (rows.length === 0) rows = undefined;
      const config = {
        quotes: true,
        quoteChar: '"',
        delimiter: ',',
        header: true,
        newline: '\r\n'
      };
      const csvData = {
        fields: headers,
        data: rows
      };
      const csv = Papa.unparse(csvData, config);

      const blob = new Blob([csv], {
        type: 'text/csv;charset=utf-8;'
      });

      const filename = `visitors_log_${moment(this.selectedDate).format(
        'DD_MM_YYYY'
      )}.csv`;
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';

          link.click();
        }
      }
    }
  }
};
</script>
<style>
#visitorLogTable .v-table__overflow {
  height: 404px;
  overflow-y: scroll;
  overflow-x: visible;
}
</style>

